export default "__VITE_ASSET__e9e214af__$_?component__"